import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5", // Fondo suave
      }}
    >
      <CircularProgress size={70} thickness={5} />
      <Typography
        variant="h6"
        sx={{ mt: 3, color: "#1976d2", fontWeight: "bold" }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;